// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"116":"806a4b28","475":"2b5bd3eb"}[chunkId] + ".js";
};